export enum CodStateCode {
  OK = 1,
  ERROR = 0,
}
